import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import { Modal } from 'bootstrap';
import InterestsConfig from './FormConfiguration/InterestsGeneralConfig.json';
import ProfileMarkerService from './ProfileMakerService';
import { Tooltip } from 'bootstrap';
import { allowPerformAction, displayActionNotAllowedAlert, isEmpty } from '../../../../../../library/Core/SmartFunctions';
import EditInterestsModal from './EditInterestsModal';

type GeneralProps = {
    activeOnWtapp: { label: string; toolTip: string; isComment: string };
    respondedToFeedBackSurvey:{ label: string,isComment :string, toolTip:string};
    respondedCallForInformation :{label :string, toolTip:string,isComment: string};
    respondedCallForProfileCreation :{label :string, toolTip:string,isComment: string};
    respondedCallForEventInvitation :{label :string, toolTip:string,isComment: string},
    respondedCallForRecruitmentCampaign :{label :string, toolTip:string,isComment: string},
    respondedCallForDonationCampaign :{label :string, toolTip:string,isComment: string},
    hadConversationWithPlacememtCell :{label :string, toolTip:string,isComment: string},
    hadConversationWithRegardingFundraise:{label :string, toolTip:string,isComment: string},
};

const GeneralProps: GeneralProps = {
    activeOnWtapp: {
        label: 'Active on WhatsApp group for batch/chapter',
        toolTip: "Alumnus is active on the WhatsApp groups created for his batch or chapter",
        isComment: 'activeOnWtappComment',
    },
    respondedToFeedBackSurvey:{ label: 'Responded to Feedback Survey',isComment:'respondedToFeedBackSurveyComment', toolTip:'Alumnus responded to Feedback survey through any media in last 1 year'},
    respondedCallForInformation:{ label: 'Called for Information or Query resolution',isComment:'respondedCallForInformationComment',toolTip:'Alumnus had a telephonic conversation regarding some general information'},
    respondedCallForProfileCreation:{ label: 'Responded to phone call for profile update',isComment:'respondedCallForProfileCreationComment',toolTip:'Alumnus had a telephonic conversation regarding profile creation or updation'},
    respondedCallForEventInvitation:{ label: 'Responded to phone call for event invitation',isComment:'respondedCallForEventInvitationComment',toolTip:'Alumnus had a telephonic conversation regarding any event invite'},
    respondedCallForRecruitmentCampaign:{ label: 'Responded to phone call for recruitment campaign',isComment:'respondedCallForRecruitmentCampaignComment',toolTip:'Alumnus had a telephonic conversation regarding campus placements'},
    respondedCallForDonationCampaign:{ label: 'Responded to phone call for donation campaign',isComment:'respondedCallForDonationCampaignComment',toolTip:'Alumnus had a telephonic conversation regarding fundraise'},
    hadConversationWithPlacememtCell:{ label: 'Had a conversation with placement cell',isComment:'hadConversationWithPlacememtCellComment',toolTip:'Alumnus had a conversation regarding placements with institute placement cell'},
    hadConversationWithRegardingFundraise:{ label: 'Had a conversation regarding fundraise',isComment:'hadConversationWithRegardingFundraiseComment',toolTip:'Alumnus had a conversation regarding fundraise with the institute'},

};

const keys = Object.keys(GeneralProps) as (keyof GeneralProps)[];
const General = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { handleOpenLogsModal} = ProfileMarkerService();
    const [loading, setLoading] = useState(true);
    // const [feedbackSurvey,setFeedbackSurvey]=useState();

    const handleOpenModal = async (key: string) => {
        if (!allowPerformAction()) {
            displayActionNotAllowedAlert();
            return;
        }
        dispatch({
            type: 'REFRESH_DATA',
            payload: { data: { ...state.data, visibleControl: key } },
        });
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showInterestsModal' } });
    };

    const model = state.internal.model;
    const [isConfigAvailable, setisConfigAvailable] = useState(false);
    const markers = state.data.marker || [];

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, [state.data.general]);

    useEffect(() => {
        // Make a shallow copy of the interests state
        const interestsData = { ...state.data.general };

        // Iterate over each key in IntrestsProps
        Object.keys(GeneralProps).forEach((key) => {
            const intrestsKey = key as keyof GeneralProps;
            const prop = GeneralProps[intrestsKey];

            if (prop && typeof prop === 'object' && 'isComment' in prop) {
                const isCommentField = prop.isComment;
                if (interestsData[intrestsKey] === false) {
                    // Reset comment field if interest is false
                    if (isCommentField) {
                        interestsData[isCommentField as keyof typeof interestsData] = '';
                    }

                    // reset the interest value itself
                    interestsData[intrestsKey] = '';
                }
            }
        });

        // Check if the new interestsData is different from the current state
        if (JSON.stringify(state.data.general) !== JSON.stringify(interestsData)) {
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'general', value: interestsData },
            });
        }
    }, [state.data.general, dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const domainMap = new Map([...state.domain]);

                const config = await Promise.resolve(InterestsConfig);

                // const respondedData = await getResponsdedFeedbackSurvey(
                //     state.internal.model.id,
                //     state.data.selectedInstitute?.instituteId              
                //  );
                // console.log('respondedData fetched', respondedData);
                // setFeedbackSurvey(respondedData?.isRespondedFeedback);

                dispatch({
                    type: 'DATA_INIT',
                    payload: {
                        formConfig: config,
                        data: {
                            ...state.data,
                            general: {
                                ...state.data.marker?.general,
                            },
                            visibleControl: {},
                        },
                        domain: domainMap,
                        internal: state.internal,
                        routeInfo: state.routeInfo,
                    },
                });
                setisConfigAvailable(true);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

   const isMarkerEnabled = (key: string): boolean => {
        // if (key === "respondedToFeedBackSurvey") {
        //     return feedbackSurvey !== 0 && feedbackSurvey !== null && feedbackSurvey !== undefined;
        // }
        const value = markers?.general?.[key];
        if (value === true) return true;
        if (typeof value === "string" && !isEmpty(value)) return true;

        return false;
    };


    return (
        <div className="tab-pane fade show active" id="pills-general" role="tabpanel" aria-labelledby="pills-general-tab">
            <div className="d-flex flex-wrap flex-column flex-md-row">
                <div
                    className="nav flex-row flex-md-column nav-pills custom-sub-tab"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"></div>
                <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 flex-1" id="v-pills-tabContent">
                    {/* Campaign */}
                    <div className="tab-pane fade show active" id="v-pills-campaign" role="tabpanel" aria-labelledby="v-pills-campaign-tab">
                        <div className="max-540 mx-auto">
                            <div className="row g-3">
                                {/* Replace this block with dynamic data */}
                                {keys.map((key) => {
                                    const markerExists = markers?.general ? key in markers.general : false;
                                    const markerEnabled = isMarkerEnabled(key);
                                    const markerClass = markerEnabled ? (markers?.general?.[key] == 'Unsubscribed' ? 'red' : '') : '';
                                    const commentField = (GeneralProps[key] as { label: string; isComment?: string }).isComment;
                                    const comment = commentField
                                        ? (markers?.general?.[commentField] ?? state.data.general?.[commentField] ?? '')
                                        : '';

                                    const value = markerExists ? markers.general[key] : null;

                                    return (
                                        <div className="col-12" key={key}>
                                            <div className="row g-3 align-items-center">
                                                <div className="col">
                                                    <div className={`listed-border ${markerEnabled ? markerClass : 'disabled'}`}>
                                                        {' '}
                                                        <i className="tick"></i>
                                                        {/* <p onClick={() => handleOpenModal(key)}>{GeneralProps[key].label} </p> */}
                                                         <p
                                                                onClick={() => !loading && handleOpenModal(key)}
                                                                style={{ cursor: loading ? "not-allowed" : "pointer" }}>
                                                                {GeneralProps[key].label}
                                                                </p>
                                                        {comment !== undefined && comment !== null && comment.trim() !== '' && (
                                                            <span
                                                                className="note-wrap"
                                                                data-bs-toggle="tooltip"
                                                                data-bs-html="true"
                                                                title={comment}>
                                                                <i className="icon-note"></i>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <i
                                                        className="icon-info"
                                                        data-bs-toggle="tooltip"
                                                        title=""
                                                        data-bs-original-title={GeneralProps[key].toolTip}
                                                        aria-label={GeneralProps[key].toolTip}></i>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="col-12 pt-3">
                                    <button className="btn btn-dark-blue w-auto height-40 px-4 d-flex align-items-center mx-auto" onClick={() => handleOpenLogsModal()}>
                                    <span className="text-white">View Update Logs</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isConfigAvailable && <EditInterestsModal userdata={{ model }} markerType="general" />}
        </div>
    );
};

export default General;
